<template>
  <div>
    <Nav></Nav>
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <h1> Categorias de insumos</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button variant="default" @click="$router.push('/supplycategory')">Crear Categoria</b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Buscar:">
            <b-form-input type="search" v-model="search" @keyup="page=1" debounce="500"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table small
          stacked="sm"
            :filter="search"
            striped
            hover
            :items="suppliesTable"
            :fields="tableFields"
            responsive
            :per-page="byPage"
            :current-page="page"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>

            <template #cell(buttons)="data">
              <b-button-group vertical>
                <b-button size="sm" variant="warning" @click="$router.push('/supplycategory/' + data.item.id)"
                  >Editar</b-button
                >
                
              </b-button-group>
            </template>
            <template #cell(status)="data"> 
                <b-badge pill v-if="data.item.status" variant="success">ACTIVO</b-badge>
                <b-badge pill v-else-if="!data.item.status" variant="danger">INACTIVO</b-badge>
            </template>
            <template #cell(image)="data"> 
              <img :src="axios.defaults.baseURL + '/' +data.item.image">
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            v-model="page"
            :total-rows="suppliesTable.length"
            :per-page="byPage"
            aria-controls="my-table"
    ></b-pagination>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import Nav from "../components/Nav.vue";
import axios from "axios";
export default {
  name: "Supplycategories",
  components: { Nav },
  data() {
    return {
      byPage:20,
      page:1,
      suppliesTable: [],
      search: "",
      subgroups:[],
      groups:[],
      tableFields: [
        { key: "id", label: "ID", sortable: true, sortDirection: "desc" },
        { key: "name", label: "Nombre" },
        { key: "status", label: "Status", sortable: true },
        { key: "buttons", label: "", sortable: true },

      ],
    };
  },
  mounted() {
    this.getAllSupplies();
  },
  methods: {
    getAllSupplies() {
      let that = this;
      axios
        .get("/supplycategories")
        .then(function (response) {
          that.suppliesTable = response.data;
        })
        .catch(function (err) {
          console.error(err)
          that.makeToast("Error", err.request.response, "danger");
        }); 
    },
    makeToast(title, content, variant) {
      this.$bvToast.toast(content, {
        title,
        variant,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
